export const getTrackingStatus = (lastTrackingEventStatus: string | null) => {
  return lastTrackingEventStatus
    ? lastTrackingEventStatus.charAt(0).toUpperCase() + lastTrackingEventStatus.slice(1).replace(/_/g, ' ')
    : 'Info received'
}

export const getLinkToTrackingPage = (trackingNumber: string, branding?: string | null) =>
  branding
    ? `https://${branding}.pacsortonline.com/tracking/${trackingNumber}`
    : `${import.meta.env.VITE_APP_TRACKING_URL}/${trackingNumber}`
